import {
  Button,
  Dialog,
  DialogFooter,
  DialogBody,
} from '@spotoninc/nexus-react';

export default function DeactivateUserDialog({ isOpen, onClose, onSubmit }) {
  return (
    <>
      <Dialog title="Deactivate user?" isOpen={isOpen} onClose={onClose}>
        <DialogBody>
          Deactivating this user will remove their access to the account.
        </DialogBody>
        <DialogFooter>
          <Button variant="tonal" onClick={onClose}>
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: '#D54041',
              _hover: { backgroundColor: '#E2E8F0' },
            }}
            onClick={() => {
              onClose();
              onSubmit();
            }}
          >
            Deactivate
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}
